<template>
  <div class="inspiration">
    <div class="video" :class="{videoPaused, mouseMoved}" @click="togglePlay">
      <video ref="video" preload src="https://video.seenthis.se/public/misc/brand/video.mp4"></video>
      <button>
        <svg fill="#ffffff" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path d="M8 5v14l11-7z" v-if="videoPaused"/>
          <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" v-else/>
        </svg>
      </button>
    </div>
    <div class="images">
      <div><img src="/images/inspiration/inspiration-1.jpg"></div>
      <div>
        <img src="/images/inspiration/inspiration-2.jpg">
        <img src="/images/inspiration/inspiration-4.jpg">
      </div>
      <div>
        <img src="/images/inspiration/inspiration-5.jpg">
        <img src="/images/inspiration/inspiration-7.jpg">
      </div>
      <div><img src="/images/inspiration/inspiration-3.jpg"></div>

      <div><img src="/images/inspiration/inspiration-6.jpg"></div>
      <div><img src="/images/inspiration/inspiration-8.jpg"></div>
      <div><img src="/images/inspiration/inspiration-9.jpg"></div>
      <div><img src="/images/inspiration/inspiration-10.jpg"></div>
      <div><img src="/images/inspiration/inspiration-11.jpg"></div>
      <div><img src="/images/inspiration/inspiration-12.jpg"></div>
      <div><img src="/images/inspiration/inspiration-13.jpg"></div>
      <div><img src="/images/inspiration/inspiration-14.jpg"></div>
      <div><img src="/images/inspiration/inspiration-16.jpg"></div>
      <div><img src="/images/inspiration/inspiration-15.jpg"></div>
      <div><img src="/images/inspiration/inspiration-17.jpg"></div>
      <div><img src="/images/inspiration/inspiration-18.jpg"></div>
      <div><img src="/images/inspiration/inspiration-19.jpg"></div>
      <div><img src="/images/inspiration/inspiration-20.jpg"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Inspiration',
  data() {
    return {
      videoPaused: true,
      mouseMoved: false,
    };
  },
  mounted() {
    const updatePause = () => {
      this.videoPaused = this.$refs.video.paused;
    };
    this.$refs.video.addEventListener('pause', updatePause);
    this.$refs.video.addEventListener('play', updatePause);
    this.$refs.video.addEventListener('mousemove', () => this.moved());
  },
  methods: {
    moved() {
      let timer = null;
      if (timer) {
        clearTimeout('timer');
      }
      timer = setTimeout(() => {
        this.mouseMoved = false;
      }, 2000);
      this.mouseMoved = true;
    },
    togglePlay() {
      this.moved();
      if (this.$refs.video.paused) {
        this.$refs.video.play();
      } else {
        this.$refs.video.pause();
      }
    },
  },
};
</script>


<style lang="stylus" scoped>
  .video
    width: 100%
    height: 56vw
    max-height: calc(100vh - 98px)
    position: relative
    &.mouseMoved button, &.videoPaused button
      opacity: 1
    video
      display: block
      width: 100%
      height: 100%
      object-fit: cover
    button
      position: absolute
      width: 50px
      height: 50px
      margin: auto
      top: 0
      right: 0
      bottom: 0
      left: 0
      opacity:0
      appearance: none
      outline: none
      display: flex
      align-items: center
      justify-content: center
      background-color: #ff5500
      border: none
      border-radius: 50%
      transition: opacity .4s
  .images
    display: grid
    grid-template-columns: 1fr 1fr
    grid-column-gap: 20px;
    grid-row-gap: 20px
    width: 100%
    max-width: 1440px
    margin: 60px auto
    div
      overflow: hidden
      img
        width: 100%
        object-fit: cover

</style>
